import { render } from "./search-school.vue?vue&type=template&id=44ea52f2"
import script from "./search-school.js?vue&type=script&lang=js"
export * from "./search-school.js?vue&type=script&lang=js"

import "./search-school.vue?vue&type=style&index=0&id=44ea52f2&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__